/**
 * @generated SignedSource<<ce0a90e4a73192bb0fcbb8642f565964>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type UpdateEventParentBaseWrappersSubscriptionInput = {
  calendarIds: ReadonlyArray<string>;
  dates: ReadonlyArray<any>;
  includeAllDay?: boolean | null;
  orgRelayId: string;
  timeZone: string;
};
export type UpdateEventParentBaseWrappersSubscription$variables = {
  input: UpdateEventParentBaseWrappersSubscriptionInput;
};
export type UpdateEventParentBaseWrappersSubscription$data = {
  readonly updateEventParentBaseWrapper: {
    readonly eventParentBases: ReadonlyArray<{
      readonly id: string;
      readonly timestamp: any;
    }>;
    readonly eventParents: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly externalEventId: string;
      readonly eventParentBaseId: string | null;
      readonly eventParentBaseTimestamp: any | null;
      readonly events: ReadonlyArray<{
        readonly id: string;
        readonly title: string | null;
        readonly locked: boolean | null;
        readonly isClockwiseEvent: boolean;
        readonly isAllDay: boolean | null;
        readonly calendarIds: ReadonlyArray<string>;
        readonly organizer: {
          readonly urnValue: string;
          readonly responseStatus: ResponseStatusEnum | null;
        } | null;
        readonly attendees: ReadonlyArray<{
          readonly urnValue: string;
          readonly responseStatus: ResponseStatusEnum | null;
        }>;
        readonly creator: {
          readonly urnValue: string;
        } | null;
        readonly annotatedEvent: {
          readonly userTags: ReadonlyArray<{
            readonly tag: string;
            readonly states: ReadonlyArray<{
              readonly subjectType: SubjectUrnTypeEnum;
              readonly subjectValue: string;
              readonly value: string | null;
            }> | null;
          }> | null;
          readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
              readonly subjectType: SubjectUrnTypeEnum;
              readonly subjectValue: string;
              readonly value: string | null;
            };
          }> | null;
        } | null;
        readonly eventKey: {
          readonly externalEventId: string;
        };
        readonly location: string | null;
        readonly startTime: {
          readonly dateOrDateTime: string;
        };
        readonly endTime: {
          readonly dateOrDateTime: string;
        };
      }>;
    }>;
  } | null;
};
export type UpdateEventParentBaseWrappersSubscription = {
  variables: UpdateEventParentBaseWrappersSubscription$variables;
  response: UpdateEventParentBaseWrappersSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "EventParentBase",
  "kind": "LinkedField",
  "name": "eventParentBases",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalEventId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventParentBaseId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventParentBaseTimestamp",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClockwiseEvent",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarIds",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urnValue",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseStatus",
  "storageKey": null
},
v15 = [
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tag",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subjectType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subjectValue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTag",
  "kind": "LinkedField",
  "name": "userTags",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TagState",
      "kind": "LinkedField",
      "name": "states",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTag",
  "kind": "LinkedField",
  "name": "orgTags",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TagState",
      "kind": "LinkedField",
      "name": "state",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dateOrDateTime",
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "EventTime",
  "kind": "LinkedField",
  "name": "startTime",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "EventTime",
  "kind": "LinkedField",
  "name": "endTime",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v24 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateEventParentBaseWrappersSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventParentBaseWrapper",
        "kind": "LinkedField",
        "name": "updateEventParentBaseWrapper",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventParent",
            "kind": "LinkedField",
            "name": "eventParents",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "events",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "organizer",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "attendees",
                    "plural": true,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnnotatedEvent",
                    "kind": "LinkedField",
                    "name": "annotatedEvent",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventKey",
                    "kind": "LinkedField",
                    "name": "eventKey",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateEventParentBaseWrappersSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventParentBaseWrapper",
        "kind": "LinkedField",
        "name": "updateEventParentBaseWrapper",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventParent",
            "kind": "LinkedField",
            "name": "eventParents",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "events",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "organizer",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "attendees",
                    "plural": true,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnnotatedEvent",
                    "kind": "LinkedField",
                    "name": "annotatedEvent",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventKey",
                    "kind": "LinkedField",
                    "name": "eventKey",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f4efc827d9732395bfdb16b8ddda01d6",
    "id": null,
    "metadata": {},
    "name": "UpdateEventParentBaseWrappersSubscription",
    "operationKind": "subscription",
    "text": "subscription UpdateEventParentBaseWrappersSubscription(\n  $input: UpdateEventParentBaseWrappersSubscriptionInput!\n) {\n  updateEventParentBaseWrapper(input: $input) {\n    eventParentBases {\n      id\n      timestamp\n    }\n    eventParents {\n      __typename\n      id\n      externalEventId\n      eventParentBaseId\n      eventParentBaseTimestamp\n      events {\n        id\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n          id\n        }\n        attendees {\n          urnValue\n          responseStatus\n          id\n        }\n        creator {\n          urnValue\n          id\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n        }\n        endTime {\n          dateOrDateTime\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c114ff54a472a6f8d183e35f5a7566e";

export default node;
